import React from "react";
import "./Styles/profil.css"
import { Header } from "./Header.";
import Footer from "./Footer";
import PageHeader from "./PageHeader";
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import AddPhotoAlternateOutlinedIcon from '@mui/icons-material/AddPhotoAlternateOutlined';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import AvatarLoader from '../Images/avatar-loader.gif'
import axios from "axios"
import Cookies from "universal-cookie";
import { useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import dayjs, { Dayjs } from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import moment from "moment/moment";

export const Profil = () => {
    const [avatarLoad, setAvatarLoad] = React.useState(false);
    const [avatarImg, setAvatarImg] = React.useState('/broken-image.jpg');
    const avatarURL = process.env.REACT_APP_API_BASE_URL + '/images/users/';

    const [firstName, setFirstName] = React.useState('');
    const [lastName, setLastName] = React.useState('');
    const [birthDate, setBirthDate] = React.useState(dayjs());
    const [defaultDZ, setDefaultDZ] = React.useState(0);
    const [email, setEmail] = React.useState('');
    const [phone, setPhone] = React.useState('');
    const [infoLoad, setInfoLoad] = React.useState(false);

    const [oldPassword, setOldPassword] = React.useState('');
    const [newPassword, setNewPassword] = React.useState('');
    const [confirmPassword, setConfirmPassword] = React.useState('');
    const [passwordLoad, setPasswordLoad] = React.useState(false);

    const [deliveryZonesList, setDeliveryZonesList] = React.useState([]);
    const cookies = new Cookies();

    useEffect(() => {
        if (cookies.get('user').avatar !== null) {
            setAvatarImg(avatarURL + cookies.get('user').avatar)
        }

        document.title = "Mon Profil - KabaaShop"

        setFirstName(cookies.get('user').firstname)
        setLastName(cookies.get('user').lastname)
        setBirthDate(cookies.get('user').birthdate)
        setDefaultDZ(cookies.get('user').defaultDZ !== null ? cookies.get('user').defaultDZ.id : 0)
        setEmail(cookies.get('user').email)
        setPhone(cookies.get('user').contact);

        axios.get(process.env.REACT_APP_API_BASE_URL + '/api/delivery_zones', {
            headers: {
                'x-api-token': process.env.REACT_APP_API_TOKEN
            }
        }).then(a => {
            setDeliveryZonesList(a.data.filter(x => !x.zone.includes("Point Relais")));
        }).catch(error => {
            console.log(error);
        })
    }, [true])

    const handleAvatarChange = (element) => {
        setAvatarLoad(true);

        const file = element.files[0]
        let formData = new FormData()

        formData.append('file', file, file.name)
        formData.append('user', cookies.get('user').id)

        if (cookies.get('user').avatar !== null) {
            formData.append('old', cookies.get('user').avatar)
        }

        axios.post(process.env.REACT_APP_API_BASE_URL + '/services/change_avatar', formData,
            {
                headers: {
                    'x-api-token': process.env.REACT_APP_API_TOKEN,
                    'Content-Type': `multipart/form-data; boundary=${formData._boundary}`,
                }
            }).then(a => {
                setAvatarImg(avatarURL + a.data.avatar)
                setAvatarLoad(false);
                let user = cookies.get('user');
                user.avatar = a.data.avatar;

                cookies.set('user', user, { path: '/', expires: moment().add(1, 'months').toDate()})
                toast.success("Vous avez changer votre avatar !")
            }).catch(error => {
                console.log(error);
                setAvatarLoad(false);

                toast.error("Une erreur est survenue ! Veuillez réessayer !")
            })
    }

    const handleSubmitPassword = () => {
        if (!newPassword.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d\w\W]{8,}$/)) {
            toast.error("Le mot de passe doit contenir au moins 1 lettre majuscule, 1 lettre minuscule et 1 chiffre et avoir au minimum 8 caractères")
            return;
        }

        if (newPassword !== confirmPassword) {
            toast.error("Le mot de passe n'a pas été confirmé !")
            return;
        }

        setPasswordLoad(true)

        axios.get(process.env.REACT_APP_API_BASE_URL + '/services/users/verify?password=' + oldPassword,
            {
                headers: {
                    'x-api-token': cookies.get('user').setToken,
                }
            }).then(a => {
                axios.patch(process.env.REACT_APP_API_BASE_URL + '/api/users/' + cookies.get('user').id,
                    {
                        password: newPassword
                    },
                    {
                        headers: {
                            'x-api-token': cookies.get('user').setToken,
                        }
                    }).then(a => {
                        setPasswordLoad(false)

                        setOldPassword('')
                        setNewPassword('')
                        setConfirmPassword('')

                        toast.success('Votre mot de passe a bien été modifié !')
                    }).catch(error => {
                        toast.error("Une erreur est survenue ! Veuillez réessayer !")

                        setPasswordLoad(false)
                    })
            }).catch(error => {
                setPasswordLoad(false);

                if (error.response.status === 403) {
                    toast.error("L'ancien mot de passe est incorrect !")
                }
                else {
                    toast.error("Une erreur est survenue ! Veuillez réessayer !")
                }
            })
    }

    const handleSubmitUpdate = () => {
        setInfoLoad(true);

        axios.patch(process.env.REACT_APP_API_BASE_URL + '/api/users/' + cookies.get('user').id,
        {
            firstname: firstName,
            lastname: lastName,
            birthdate: birthDate,
            email: email,
            contact: phone,
            defaultDeliveryZone: 'api/delivery_zones/'+defaultDZ
        },
        {
            headers: {
                'x-api-token': cookies.get('user').setToken,
            }
        }).then(a => {
            setInfoLoad(false)

            let user = cookies.get('user');
            user.firstname = a.data.firstname;
            user.lastname = a.data.lastname;
            user.birthdate = a.data.birthdate;
            user.email = a.data.email;
            user.contact = a.data.contact;
            user.defaultDZ = a.data.defaultDeliveryZone;

            cookies.set('user', user, { path: '/', expires: moment().add(1, 'months').toDate() })

            toast.success('Vos informations ont bien été modifiées a bien été modifié !')
        }).catch(error => {
            toast.error("Une erreur est survenue ! Veuillez réessayer !")

            setInfoLoad(false)
        })
    }

    const handlePickerChange = (newValue) => {
        setBirthDate(newValue);
    };

    return (
        <>
            <ToastContainer />
            <Header />
            <PageHeader title={"Mon Profil"} />

            <div className="Profil-container">
                <div className="card-container">
                    <Card sx={{ minWidth: 275 }}>
                        <CardContent>
                            <div className="Avatar-container">
                                <Stack sx={{ position: 'relative' }} direction="row" spacing={2}>
                                    <Avatar src={avatarImg} sx={{ width: 100, height: 100 }} />
                                    <img style={{ position: 'absolute', top: '20px', display: !avatarLoad ? 'none' : 'block' }} src={AvatarLoader} />
                                </Stack>
                            </div>

                            <div className="Add-Img">
                                <label for="inputAvatar" style={{ cursor: 'pointer', display: 'flex' }}>
                                    <AddPhotoAlternateOutlinedIcon /> <div className="Img-Text"> <span>Changer l'avatar</span> </div>
                                </label>
                                <input onChange={(e) => { handleAvatarChange(e.target) }} id="inputAvatar" accept="image/jpeg, image/jpg, image/png, image/webp" type="file" style={{ display: "none" }} />
                            </div>

                            <div className="Card-Object">
                                <div className="Profil-Box">
                                    <div>
                                        <Box
                                            
                                            sx={{
                                                '& > :not(style)': { m: 1, width: '200px' },
                                            }}
                                            
                                            autoComplete="off"
                                        >
                                            <TextField disabled={infoLoad} required className="inputfield-profil" value={lastName} onChange={(e) => { setLastName(e.target.value) }} label="Nom" variant="filled" />
                                        </Box>
                                    </div>
                                    <div>

                                        <Box
                                            
                                            sx={{
                                                '& > :not(style)': { m: 1, width: '200px' },
                                            }}
                                            
                                            autoComplete="off"
                                        >
                                            <TextField disabled={infoLoad} required className="inputfield-profil" label="Prenom" value={firstName} onChange={(e) => { setFirstName(e.target.value) }} variant="filled" />
                                        </Box>
                                    </div>
                                </div>


                                <div className="Profil-Box">
                                    <div>
                                        <Box
                                            
                                            sx={{
                                                '& > :not(style)': { m: 1, width: '200px' },
                                            }}
                                            
                                            autoComplete="off"
                                        >
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <MobileDatePicker
                                                    disabled={infoLoad}
                                                    label="Date de naissance"
                                                    inputFormat="DD/MM/YYYY"
                                                    value={birthDate}
                                                    onChange={handlePickerChange}
                                                    renderInput={(params) => <TextField {...params} />}
                                                />
                                            </LocalizationProvider>
                                        </Box>
                                    </div>
                                    <div>
                                        <Box
                                            
                                            sx={{
                                                '& > :not(style)': { m: 1, width: '200px' },
                                            }}
                                            
                                            autoComplete="off"
                                        >
                                            <Select
                                                disabled={infoLoad}
                                                value={defaultDZ}
                                                label="Zone d'habitation"
                                                onChange={(e) => { setDefaultDZ(e.target.value); }}
                                                sx={{ '& legend': { display: 'none' }, '& fieldset': { display: 'none' } }}
                                            >
                                                <MenuItem value={0}>Zone d'habitation</MenuItem>
                                                {
                                                    deliveryZonesList.map(dz => {
                                                        return <MenuItem value={dz.id}>{dz.zone}</MenuItem>
                                                    })
                                                }
                                            </Select>
                                        </Box>
                                    </div>
                                </div>

                                <div className="Profil-Box">
                                    <div>
                                        <Box
                                            
                                            sx={{
                                                '& > :not(style)': { m: 1, width: '200px' },
                                            }}
                                            
                                            autoComplete="off"
                                        >
                                            <TextField disabled={infoLoad} required className="inputfield-profil" label="Adresse Email" value={email} onChange={(e) => { setEmail(e.target.value) }} variant="filled" />
                                        </Box>
                                    </div>

                                    <div>
                                        <Box
                                            className="form-controler"
                                            
                                            sx={{
                                                '& > :not(style)': { m: 1, width: '200px' },
                                            }}
                                            
                                            autoComplete="off"
                                        >
                                            <TextField disabled={infoLoad} className="inputfield-profil" label="Numéro de téléphone" value={phone} onChange={(e) => { setPhone(e.target.value) }} variant="filled" />
                                        </Box>
                                    </div>
                                </div>

                                <div className="Form-button-update" style={{ textAlign: 'center', marginTop: '15px' }}>
                                    <Button disabled={infoLoad} onClick={() => { handleSubmitUpdate() }} variant="contained">Modifier</Button>
                                </div>
                            </div>
                        </CardContent>

                    </Card>
                </div>


                <div className="card-container-mdp">
                    <Card sx={{ minWidth: 275 }}>
                        <CardContent>

                            <form onSubmit={(e) => { e.preventDefault(); handleSubmitPassword() }}>
                                <Box
                                    
                                    sx={{
                                        '& > :not(style)': { m: 1, width: '250px' },
                                    }}
                                    autoComplete="off"
                                >
                                    <TextField disabled={passwordLoad} required value={oldPassword} onChange={(e)=>{setOldPassword(e.target.value)}} type="password" className="inputfield-profil" label="Ancien mot de passe" variant="filled" />
                                </Box>


                                <Box
                                    
                                    sx={{
                                        '& > :not(style)': { m: 1, width: '250px' },
                                    }}
                                    autoComplete="off"
                                >
                                    <TextField disabled={passwordLoad} required value={newPassword} onChange={(e)=>{setNewPassword(e.target.value)}} type="password" className="inputfield-profil" label="Nouveau mot de passe" variant="filled" />
                                </Box>


                                <Box
                                    
                                    sx={{
                                        '& > :not(style)': { m: 1, width: '250px' },
                                    }}
                                    autoComplete="off"
                                >
                                    <TextField disabled={passwordLoad} required value={confirmPassword} onChange={(e)=>{setConfirmPassword(e.target.value)}} type="password" className="inputfield-profil" label="Confirmation du mot de passe" variant="filled" />
                                </Box>

                                <div className="Form-button-profil">
                                    <Button disabled={passwordLoad} type="submit" variant="contained">Confirmer</Button>
                                </div>
                            </form>

                        </CardContent>

                    </Card>

                </div>
            </div>
            <Footer />

        </>
    )
}

